<div class="grid grid-cols-1 lg:grid-cols-3 m-3 gap-y-3 lg:gap-3" *ngIf="driverStats$ | async as stat">
  <div class="row-span-2">
    <div class="card-with-shadow bg-white">
      <div class="text-lg font-bold p-2">
        Driver Scorecard <span class="text-blue-500">Past {{ stat.shift_count }} Shifts</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        Total Earnings <span class="mr-3 font-bold">{{ stat.total_earnings | currencyInPennies }}</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        Avg Earnings
        <span class="mr-3 font-bold">{{ stat.avgEarnings | currencyInPennies }}</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        Total Lost Earnings
        <span class="mr-3 font-bold" [class.text-red-500]="stat.lost_earnings > 0">{{
          stat.lost_earnings | currencyInPennies
        }}</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        Avg Lost Earnings
        <span class="mr-3 font-bold" [class.text-red-500]="stat.avgLostEarnings > 0">{{
          stat.avgLostEarnings | currencyInPennies
        }}</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        Avg Turns <span class="mr-3 font-bold">{{ stat.turns_completed | number: '1.1-1' }}</span>
      </div>
      <div class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2">
        <span
          class="border-black border-b border-dotted"
          tooltip="Driver Performance Index (DPI) is the number of<br> additional minutes a driver takes<br> to complete a typical load. Lower is better!"
          >DPI</span
        >
        <span class="mr-3 font-bold" *ngIf="stat.learningDPI === false; else learning">
          {{ stat.dpi | abs | number }}m {{ stat.dpi > 0 ? 'slower' : 'faster' }}
        </span>
        <ng-template #learning>
          <div class="mr-3 text-gray-600 font-bold">Learning...</div>
        </ng-template>
      </div>
      <div class="flex flex-row justify-between py-2 ml-2 pr-2">
        Days Worked in Past 10
        <span class="mr-3 font-bold">{{ daysToCompleteShifts$ | async | number }}</span>
      </div>
      <!--<div class="flex flex-row justify-between py-2 ml-2 pr-2">
        Past 7d Lost Earnings %
        <span
          class="mr-3 font-bold"
          [class.text-red-500]="stat.lost_earnings / (stat.total_earnings + stat.lost_earnings) > 0.1"
        >
          {{ (stat.lost_earnings / (stat.total_earnings + stat.lost_earnings)) * 100 | number }}%</span
        >
      </div>-->
    </div>
    <ng-container *ngIf="!(currentUser$ | async).earningsProgramMember">
      <ng-container *ngIf="reportImprovements$$ | async as reportImprovements">
        <div class="mt-3">
          <div class="card-with-shadow bg-white">
            <div class="text-lg font-bold p-2">
              Driver Coaching <span class="text-blue-500">Past {{ reportImprovements.numShifts }} Shifts</span>
            </div>
            <ng-container *ngIf="reportImprovements.improvements?.length; else noFixes">
              <div class="p-2">
                <span class="text-gray-600">
                  {{ (currentDriver$ | async).driverName }} would have made an additional
                  {{ reportImprovements.lostEarningsCents | currencyInPennies }} in the last
                  {{ reportImprovements.numShifts }} shifts if they did these things.
                </span>
              </div>
              <div
                *ngFor="let improvement of reportImprovements?.improvements; trackBy: 'rank' | trackByKey"
                class="flex flex-row justify-between py-2 border-b border-gray-400 ml-2 pr-2 last:border-0"
              >
                <span> {{ improvement.rank }}. {{ improvement.suggestion }} </span>
                <span class="text-red-500 font-bold">
                  {{ improvement.lostCents | currencyInPennies }}
                </span>
              </div>
            </ng-container>
            <ng-template #noFixes>
              <div class="p-2">
                <span class="text-gray-600">
                  {{ (currentDriver$ | async).driverName }} has maximized their earnings!
                </span>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="col-span-2">
    <lohi-earnings-chart
      [earningsPerDay]="stat.driver_earnings_per_day"
      [driverTarget]="$any(currentDriver$ | async).driverTarget"
    ></lohi-earnings-chart>
  </div>
  <div class="col-span-2">
    <lohi-loads-chart [earningsPerDay]="stat.driver_earnings_per_day"></lohi-loads-chart>
  </div>
</div>
